import i18n from "../i18n/i18n";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateEmailInput(email) {
  if (!email) {
    return i18n.t("errors.pleaseEnterEmail", "Please enter your email address.");
  }
  if (!emailRegex.test(email)) {
    return i18n.t("errors.pleaseEnterValidEmail", "Please enter a valid email address.");
  }
  return null;
}

export function parseForgotPasswordError(error) {
  const status = error?.status ?? error?.response?.status;

  if (!status) {
    return i18n.t("errors.unexpectedError", "An unexpected error occurred. Please try again later.");
  }

  switch (status) {
    case 404:
      return i18n.t("errors.noAccountFound", "No account found with the provided email address.");
    case 400:
      return i18n.t("errors.invalidRequest", "Invalid request. Please check your input.");
    case 500:
      return i18n.t("errors.serverError", "Server error. Please try again later.");
    case 502:
    case 503:
    case 504:
      return i18n.t("errors.serviceUnavailable", "Service is temporarily unavailable. Please try again later.");
    default:
      return i18n.t("errors.genericError", "An error occurred. Please try again.");
  }
}
